import { api } from "@/app/services/api.service";
import { unwrapPayload } from "./gatewayApi";

export const SMS_GATEWAY_PATH = "notifications/config/sms-gateway";

export const SMS_GATEWAY_OPTIONS = [
  { value: "UGPASS", label: "UGPASS" },
  { value: "INSTACOM", label: "Instacom" },
  { value: "INFOBIP", label: "Infobip" },
] as const;

export type SmsGatewayValue = (typeof SMS_GATEWAY_OPTIONS)[number]["value"];

const allowedValues: readonly string[] = SMS_GATEWAY_OPTIONS.map((o) => o.value);

export function parseSmsGateway(body: unknown): SmsGatewayValue | null {
  if (body == null) return null;
  let raw: unknown = body;
  if (typeof body === "object") {
    const record = body as Record<string, unknown>;
    raw = record.gateway ?? record.activeGateway ?? record.provider;
  }
  if (typeof raw !== "string") return null;
  const value = raw.trim().toUpperCase();
  return allowedValues.includes(value) ? (value as SmsGatewayValue) : null;
}

export async function fetchSmsGateway(): Promise<SmsGatewayValue | null> {
  const res = await api().get(SMS_GATEWAY_PATH);
  return parseSmsGateway(unwrapPayload(res));
}

export async function saveSmsGateway(gateway: SmsGatewayValue) {
  await api().put(SMS_GATEWAY_PATH, { gateway });
}
